import { Navigate } from "react-router-dom";

const ProtectedAdminRoute = ({ children }) => {

  const user = sessionStorage.getItem("user");

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  try {
    const parsedUser = JSON.parse(user);

    if (!parsedUser.token || parsedUser.role !== "admin") {
      return <Navigate to="/login" replace />;
    }

  } catch (e) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedAdminRoute;
